"use client";

import { useAppSettings } from "@/shared";

export function SidebarMinifyBtn() {
  const { settings, updateSettings } = useAppSettings();

  const toggleAppSidebarMinified = () => {
    updateSettings({
      appSidebarMinified: !settings.appSidebarMinified,
    });
  };

  return (
    <div className="menu">
      <div className="menu-item d-flex">
        <button
          className="app-sidebar-minify-btn ms-auto"
          onClick={toggleAppSidebarMinified}
        >
          <i className="fa fa-angle-double-left"></i>
        </button>
      </div>
    </div>
  );
}
